import { render, staticRenderFns } from "./SmartSearchTest.vue?vue&type=template&id=50225c2b&scoped=true"
import script from "./SmartSearchTest.vue?vue&type=script&lang=js"
export * from "./SmartSearchTest.vue?vue&type=script&lang=js"
import style0 from "./SmartSearchTest.vue?vue&type=style&index=0&id=50225c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50225c2b",
  null
  
)

export default component.exports